import * as i0 from "@angular/core";
function getLocalStorage() {
    return localStorage;
}
var LocalStorageRefService = /** @class */ (function () {
    function LocalStorageRefService() {
    }
    Object.defineProperty(LocalStorageRefService.prototype, "localStorage", {
        get: function () {
            return getLocalStorage();
        },
        enumerable: true,
        configurable: true
    });
    LocalStorageRefService.ngInjectableDef = i0.defineInjectable({ factory: function LocalStorageRefService_Factory() { return new LocalStorageRefService(); }, token: LocalStorageRefService, providedIn: "root" });
    return LocalStorageRefService;
}());
export { LocalStorageRefService };
